import React from 'react'
import PropTypes from 'prop-types'
import Box from '@material-ui/core/Box'
import CoachPhotos from '@components/coach-photos'
import TestimonialV2 from '@components/testimonialv2'
import useStyles from './coach-offering-group-events.styles'

function CoachOfferingGroupEvents({
  coach,
  photosJsonData,
  testimonialsJsonData,
}) {
  const classes = useStyles()
  const hasPhotos = photosJsonData && photosJsonData.length > 0
  const hasTestimonials = testimonialsJsonData && testimonialsJsonData.length > 0

  if (!hasPhotos && !hasTestimonials) {
    return null
  }

  return (
    <Box className={classes.offeringsRoot}>
      {hasPhotos && (
        <CoachPhotos photos={photosJsonData} firstName={coach.firstName} />
      )}
      {hasTestimonials && (
        <TestimonialV2 testimonialsData={testimonialsJsonData} />
      )}
    </Box>
  )
}

CoachOfferingGroupEvents.propTypes = {
  coach: PropTypes.object.isRequired,
  photosJsonData: PropTypes.array,
  testimonialsJsonData: PropTypes.array,
}

CoachOfferingGroupEvents.defaultProps = {
  photosJsonData: undefined,
  testimonialsJsonData: undefined,
}

export default CoachOfferingGroupEvents
